<template>
	<div class="page-mdl">
		
		
		<content-pc v-if="!isMobile"></content-pc>
		<content-mobile v-if="isMobile"></content-mobile>
		
		
	</div>
</template>

<script>
import contentPc from './tpl-pc.vue'
import contentMobile from './tpl-mobile.vue'
export default {
	name: 'index',
	components:{
		contentPc,
		contentMobile
	},
	data () {
		return {
			navIndex:-1
		}
	},
	
	created(){
		
	},
  
	computed:{
		
	},
  
	methods:{
		
	}
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/colleges-detail/index.vue